
import {Rest} from 'utils'
import {API_ADMIN_WEAVIATE} from 'consts/api'

export default {
  props: {
    coll_name: {type: String, required: true}
  },
  data() {
    return {
      coll: undefined,
      rest: new Rest()
    }
  },
  computed: {
    ii_config() {
      const ii_config = this.coll.ii_config
      return {
        'bm25': JSON.stringify(ii_config.bm25)
      }
    }
  },
  watch: {
    coll_name: {
      handler: async function () {
        await this.load()
      },
      immediate: true
    }
  },
  methods: {
    async load() {
      this.coll = await this.rest.get(`${API_ADMIN_WEAVIATE}/collections/${this.coll_name}`)
    }
  }
}
